var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenEnergy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "55px",
    viewBox: "0 0 49 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Green Energy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Green-Energy",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,30 L23.5,34 C23.4472912,42.6843843 23.4472912,47.0177536 23.5,47.000108 C36.4786916,47.000108 47,36.4786916 47,23.5 C47,10.5213084 36.4786916,-2.13162821e-14 23.5,-2.13162821e-14 C10.5213084,-2.13162821e-14 0,10.5213084 0,23.5 C0,28.731431 1.7094206,33.5636055 4.6001629,37.4684245",
    id: "Oval",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(15.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 7,
    width: 17,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3,
    y: 0,
    width: 3,
    height: 7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 11,
    y: 0,
    width: 3,
    height: 7,
    rx: 1
  })), /*#__PURE__*/React.createElement("line", {
    x1: 9.2151393,
    y1: 35.1645007,
    x2: 9.32697405,
    y2: 46.9324378,
    id: "Path-4",
    strokeLinecap: "round",
    transform: "translate(9.271057, 41.048469) rotate(128.000000) translate(-9.271057, -41.048469) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 40,
    x2: 12,
    y2: 42,
    id: "Path-5",
    strokeLinecap: "round",
    transform: "translate(11.000000, 41.000000) rotate(128.000000) translate(-11.000000, -41.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 40,
    x2: 6,
    y2: 42,
    id: "Path-6",
    strokeLinecap: "round",
    transform: "translate(7.000000, 41.000000) rotate(128.000000) translate(-7.000000, -41.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8918579,50.5472737 C14.994422,46.2489547 17.045704,42.9669035 17.045704,40.7011199 C17.045704,37.3024445 14.2905332,34.5472737 10.8918579,34.5472737 C7.49318247,34.5472737 4.7380117,37.3024445 4.7380117,40.7011199 C4.7380117,42.9669035 6.78929375,46.2489547 10.8918579,50.5472737 Z",
    id: "Oval",
    transform: "translate(10.891858, 42.547274) rotate(-54.000000) translate(-10.891858, -42.547274) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEnergy);
export default __webpack_public_path__ + "static/media/greenEnergy.96a1634eff829ee495d174d0232d1c08.svg";
export { ForwardRef as ReactComponent };